<!-- (input) di-stopPropagation di tiap <input type="file"> — consumer pasang formControlName +
     ngDefaultControl di host <app-document-upload>, jadi DefaultValueAccessor Angular ikut nangkap
     event `input` yang bubble dari file input dan nulis "C:\fakepath\<nama file>" ke FormControl.
     Efeknya nilai form tercemar dan re-render bikin handler (change) gak pernah jalan (upload
     batal, preview kosong). Cukup blokir `input`; `change` tetap dipakai onFileChange. -->
<div class="d-flex flex-wrap align-items-start mb-6">
  <label
    *ngIf="showLabel"
    class="col-12 {{ customColClass.label }} col-form-label"
    [class.required]="required"
    >{{ label }}</label
  >
  <div
    class="col-12"
    [ngClass]="[
      showLabel || isStackedItem ? customColClass.content : '',
      isStackedItem ? 'ms-auto' : '',
    ]"
  >
    <ng-container *ngIf="hasFileData() || hasInputData(); else uploaderTpl">
      <div class="dropzone dropzone-{{ style }} dropzone-panel">
        <ng-container [ngTemplateOutlet]="previewTpl"></ng-container>
        <ng-container *ngIf="type === 'IMAGE' && enableDelete && fileUrlSubject.value">
          <input
            type="file"
            class="d-none"
            id="input-doc__{{ UniqueLabelID }}"
            (change)="onFileChange($event)"
            (input)="$event.stopPropagation()"
            [accept]="ALLOWED_EXTENSIONS"
            [disabled]="isDisabled"
            [class.disabled]="isDisabled"
          />
          <label
            for="input-doc__{{ UniqueLabelID }}"
            class="mt-6 cursor-pointer"
            [ngStyle]="(isLoading$ | async) ? { 'pointer-events': 'none' } : null"
          >
            <span class="text-decoration-underline text-info-label fw-bold mt-n6">{{
              ctaLabelFile
            }}</span>
          </label>
        </ng-container>
        <ng-container *ngIf="type === 'FILE' && enableDelete && fileUrlSubject.value">
          <input
            type="file"
            class="d-none"
            id="input-doc-file__{{ UniqueLabelID }}"
            (change)="onFileChange($event)"
            (input)="$event.stopPropagation()"
            [accept]="ALLOWED_EXTENSIONS"
            [disabled]="isDisabled"
            [class.disabled]="isDisabled"
          />
          <label
            for="input-doc-file__{{ UniqueLabelID }}"
            class="mt-2 cursor-pointer d-inline-block"
            [ngStyle]="(isLoading$ | async) ? { 'pointer-events': 'none' } : null"
          >
            <span class="text-decoration-underline text-info-label fw-bold">{{
              ctaLabelFile
            }}</span>
          </label>
        </ng-container>
      </div>
    </ng-container>

    <ng-template #uploaderTpl>
      <div
        appDnd
        class="dropzone dropzone-{{ style }} dropzone-panel"
        [class.error]="hasError"
        (filesChangeEmitter)="handleFileChange($event)"
      >
        <input
          type="file"
          class="d-none"
          id="input-doc__{{ UniqueLabelID }}"
          (change)="onFileChange($event)"
          (input)="$event.stopPropagation()"
          [accept]="ALLOWED_EXTENSIONS"
          [disabled]="isDisabled"
          [class.disabled]="isDisabled"
        />

        <ng-container *ngIf="isLoading$ | async">
          <ng-container *ngTemplateOutlet="loaderSpinner"></ng-container>
        </ng-container>

        <label
          *ngIf="!isLoadingSubject.value"
          for="input-doc__{{ UniqueLabelID }}"
          class="d-flex align-items-center justify-content-center flex-column mt-6 cursor-pointer"
        >
          <ng-container *ngIf="!fileUrlSubject.value">
            <ng-container *ngIf="hasError; else defaultIconUpload">
              <span class="svg-icon" [inlineSVG]="STRING_CONSTANTS.ICON.IC_DANGER"></span>
            </ng-container>

            <ng-template #defaultIconUpload>
              <span
                class="svg-icon svg-icon-uploader"
                [inlineSVG]="STRING_CONSTANTS.ICON.IC_UPLOAD_FILE"
              ></span>
            </ng-template>

            <span class="my-6 fw-bold">
              <ng-container *ngIf="hasError; else defaultTextUpload">
                <div [innerHTML]="errorMessage"></div>
                <span class="text-info-text text-decoration-underline d-block mt-4">{{
                  ctaLabelFile
                }}</span>
              </ng-container>

              <ng-template #defaultTextUpload>
                Drag file here or click to upload,<br />
                or <span class="text-info-text">browse</span>.
              </ng-template>
            </span>
          </ng-container>
        </label>
      </div>
    </ng-template>
  </div>
</div>

<ng-template #loaderSpinner>
  <div class="d-flex cursor-pointer align-items-center justify-content-center">
    <mat-spinner diameter="32"></mat-spinner>
  </div>
</ng-template>

<ng-template #previewTpl>
  <div class="position-relative mw-100 m-auto" [class.w-50]="type === 'IMAGE'">
    <!-- Preview lokal (FileReader) independen dari hasil upload - JANGAN disembunyikan pas hasError,
         dulu bikin box kosong tanpa gambar maupun pesan error pas upload gagal (cuma CTA doang). -->
    <ng-template [ngTemplateOutlet]="type === 'FILE' ? previewFile : previewImage"></ng-template>

    <div
      class="position-absolute start-0 end-0 top-0 bottom-0 d-flex align-items-center justify-content-center z-1"
      *ngIf="isLoading$ | async"
    >
      <ng-template [ngTemplateOutlet]="loaderSpinner"></ng-template>
    </div>
  </div>

  <ng-template #previewImage>
    <span
      *ngIf="enableDelete"
      class="img-close-icon position-absolute top-0 end-0 mt-n1 me-n2 {{ idx }}"
      [inlineSVG]="STRING_CONSTANTS.ICON.IC_BULLET_CLOSE"
      (click)="handleRemoveFile()"
    ></span>
    <img
      [src]="fileUrlSubject | async"
      alt="preview-{{ idx }}"
      class="img-thumbnail img-fluid p-2"
      [ngClass]="{ 'opacity-25': (isLoading$ | async) }"
      [ngStyle]="{ filter: (isLoading$ | async) ? 'blur(8px)' : '' }"
    />
  </ng-template>

  <ng-template #previewFile>
    <div
      class="file-download card-rounded d-flex align-items-center shadow-xs p-6"
      [class.opacity-25]="isLoading$ | async"
    >
      <button
        (click)="handleDownload()"
        class="d-flex align-items-center w-100 bg-transparent border-0"
        [disabled]="isLoading$ | async"
      >
        <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_FILE_PDF" class="svg-icon svg-icon-2"></span>
        <div class="col-auto ms-4 text-start">
          <span class="d-block mb-1 text-wrap-name">{{
            fileData ? fileData.file.name : data ? data.name : ''
          }}</span>
          <span class="d-block text-gray-700">{{ fileData ? fileData.sizeMb : '' }}</span>
        </div>
      </button>
      <span
        *ngIf="enableDelete"
        [inlineSVG]="STRING_CONSTANTS.ICON.IC_TRASH_RED"
        (click)="handleRemoveFile()"
      ></span>
    </div>
  </ng-template>
</ng-template>
